import script from "./AllTask.vue?vue&type=script&lang=ts&setup=true"
export * from "./AllTask.vue?vue&type=script&lang=ts&setup=true"

import "./AllTask.vue?vue&type=style&index=0&id=29508fa1&lang=scss&scoped=true"

import exportComponent from "E:\\svn\\xmTask(国振资产管理)1\\views\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-29508fa1"]])

export default __exports__